module.exports = __webpack_public_path__ + "img/65.dbee9144.jpg";